/**
 * Progress Section Component
 *
 * Shows evaluation progress while running:
 * - Progress bar
 * - Status text (3/5 items processed)
 * - Dataset name
 * - Animated spinner
 */

import React from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { EvaluationRunStatus } from '../../api/evaluation';

interface ProgressSectionProps {
  status: EvaluationRunStatus;
}

export const ProgressSection: React.FC<ProgressSectionProps> = ({ status }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center mb-4">
        <i className="pi pi-spin pi-spinner text-2xl text-blue-600 mr-3" />
        <h2 className="text-xl font-semibold text-gray-900">Evaluation in Progress...</h2>
      </div>

      <div className="space-y-4">
        {/* Dataset Info */}
        <div className="text-sm text-gray-600">
          <p>
            <span className="font-medium">Dataset:</span> {status.dataset_name}
          </p>
          <p>
            <span className="font-medium">Negotiation ID:</span> {status.negotiation_id}
          </p>
        </div>

        {/* Progress Bar */}
        <div>
          <ProgressBar
            value={status.progress_percentage}
            className="h-6"
            style={{ height: '1.5rem' }}
          />
          <p className="mt-2 text-sm text-gray-600 text-center">
            {status.processed_items} / {status.total_items} items processed (
            {status.progress_percentage.toFixed(1)}%)
          </p>
        </div>

        {/* Status Message */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            <i className="pi pi-info-circle mr-2" />
            Processing questions through evaluation pipeline. This may take a few minutes...
          </p>
        </div>

        {/* Polling Info */}
        <div className="text-xs text-gray-500 text-center">
          Page updates every 2 seconds automatically
        </div>
      </div>
    </div>
  );
};
